export type NetworkListener = (isOnline: boolean) => void;

class NetworkManager {
  private online = true; // optimistic default
  private listeners: NetworkListener[] = [];

  /** Web fallback: use navigator.onLine + window events. */
  initWeb(): void {
    this.setOnline(navigator.onLine);
    window.addEventListener("online", () => { this.setOnline(true); });
    window.addEventListener("offline", () => { this.setOnline(false); });
  }

  /** Synchronous online check — never async. */
  isOnline(): boolean {
    return this.online;
  }

  /** Called by appLifecycle on foreground return as a safety net reconnect. */
  handleForegroundReconnect(): void {
    this.setOnline(true);
  }

  subscribe(listener: NetworkListener): () => void {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx >= 0) {
        this.listeners.splice(idx, 1);
      }
    };
  }

  private setOnline(value: boolean): void {
    if (value === this.online) return;
    this.online = value;
    for (const listener of this.listeners) {
      listener(value);
    }
  }
}

export const networkManager = new NetworkManager();
